module.exports = __webpack_public_path__ + "img/danny-12-weeks-compressor_tn.93304959.jpg";